<template>
  <div>    
    <div class="columns">
     <!--  <div class="column is-3">
        <p class="subtitle">Categories</p>        
        <div class="card categories-container">
          <p v-if="isCategoriesLoading">Loading categories...</p>
          <tree
            v-if="!isCategoriesLoading"
            :data="categories"
            :options="treeOptions"
            @node:selected="onCategorySelected"
          />
        </div>
      </div> -->
      <div class="column is-4" v-if="!hotels">
       <p class="subtitle">Hotels</p>
       <p class="title" v-if="isHotelsLoading">Loading hotels...</p>
        <!-- <p v-if="!isHotelsLoading && !hotels">Please select a category to view its hotels.</p> -->
      </div>
     
      <div class="column   hotels-container" v-if="hotels">
        <div class="columns ">
          <div class="column is-2">
            <p class="subtitle" v-if="hotels">Hotels <strong>({{hotels.length}}) </strong></p>
          </div>
          <div class="column is-7">
            <b-field expanded>
              <b-input v-model="searchName"  type="search" icon="search" :disabled="!hotels || !hotels.length" placeholder="Search Hotels "></b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <a class="button is-primary full-width-button" @click="openModal" >
              <span class="icon is-small">
                <i class="fas fa-plus"></i>
              </span>
              <span>Add</span>
            </a>
          </div>
        </div>
         
        <div class="columns is-multiline">
         <p class="title" v-if="isHotelsLoading">Loading hotels...</p>  
          <div class="column is-4" v-if="!isHotelsLoading && hotels" v-for="hotel in filterBy(hotels, searchName)" :key="hotel.docId">
            <div v-if="hotels.length">
              
              <div class="card">
               
                   <header class="card-header">
                     <img class="hotel-image has-text-centered " :src="hotel.imageUrl || '/static/placeholder_image.png'" alt="Placeholder image">
                     <p class="card-header-title">
                     
                    {{hotel.name | truncate(20)}},
                    {{hotel.city | truncate(20)}}
                    </p>
                  </header>
                
                 
                <div class="card-content">
              
                  <div class="media">
                    <div class="media-content">
                      <p ><strong> Hotel Code :</strong>  {{hotel.code | truncate(20)}}</p>
                      <p ><strong> Manager Name :</strong>  {{hotel.manager | truncate(20)}}</p>
                      <p ><strong> Manager Mobile :</strong>  {{hotel.m_mobile | truncate(20)}}</p>
                      <p ><strong> Manager Email :</strong>  {{hotel.m_email }}</p>
                      <p ><strong> Hotel Phone :</strong>  {{hotel.no }}</p>
                      <p ><strong> Hotel Email :</strong>  {{hotel.email }}</p>
                      <p ><strong> Hotel Website :</strong>  {{hotel.website }}</p>
                      <p ><strong> Hotel Pincode :</strong>  {{hotel.pincode }}</p>
                      <rate class="title is-5 has-text-centered" :length="5" :value="hotel.star" :readonly="true"  :title="hotel.star" > </rate>
                    </div>
                  </div>
                </div> 
                  <footer class="card-footer">
                    <a class="card-footer-item" @click="openModal(hotel)" title="Edit hotel">
                      <b-icon type='is-primary' size="is-small" icon="edit"></b-icon>
                    </a>
                    <a class="card-footer-item" @click="deleteHotel(hotel)" title="Delete hotel">
                      <b-icon type='is-info' size="is-small" icon="trash"></b-icon>
                    </a>
                    <b-upload class="card-footer-item" v-model="files" @input="uploadImage(hotel)">
                      <a title="Upload image">
                        <b-icon type='is-info' size="is-small" icon="upload"></b-icon>
                      </a>
                    </b-upload>
                  </footer>
              
            </div>
            </div> 
          </div></div>
        
      </div>
    </div>
  </div>
</template>

<script>
import AddHotel from './AddHotel';
import HotelsService from './service';
import UploadService from '../../lib/UploadService';

export default {
  name: 'hotels',

  created() {
    this.fetchHotels();

    this.$bus.$on('HOTEL_UPDATE', (updatedHotel, isNewHotel) => {
      if (isNewHotel) {
        this.hotels.unshift(updatedHotel);
      } else {
        this.hotels = this.hotels.map(hotel => {
          if (hotel.docId === updatedHotel.docId) {
            return updatedHotel;
          }

          return hotel;
        });
      }
    });
  },

  components: {
    AddHotel
  },

  data() {
    return {
     // isCategoriesLoading: true,
      isHotelsLoading: false,
      searchName: null,
      isAddUpdateHotelModalOpen: false,
      //categories: null,
      files: null,
      isLoading: true,
      //currentSelectedCategory: null,
      hotels: [],
     
      treeOptions: {
        propertyNames: {
          text: 'name',
         // children: 'subcategories'
        }
      }
    };
  },

  methods: {
    /* fetchCategories() {
      HotelsService.categories().then(categories => {
        this.categories = categories;
        this.isCategoriesLoading = false;
      });
    },

    onCategorySelected(category) {
      this.currentSelectedCategory = category;
      this.fetchHotels(category.id);
    }, */

    fetchHotels() {
      this.isHotelsLoading = true;
      this.hotels = null;

      HotelsService.all().then(hotels => {
        this.hotels = hotels;
        this.isHotelsLoading = false;
      });
    },

    deleteHotel(hotelToDelete) {
      this.isHotelsLoading = true;
    this.$dialog.confirm({
    message: 'Sure to delete hotel?',
        onConfirm: () => {
      HotelsService.deleteHotel(hotelToDelete.docId).then(() => {
        this.hotels = this.hotels.filter(
          hotel => hotelToDelete.docId !== hotel.docId
        );
        this.isHotelsLoading = false;
        this.$toast.open('Hotel deleted successfully');
      });
        }
});
    },

    openModal(hotel = null) {
      this.$modal.open({
        parent: this,
        props: {
          propHotel: hotel,
         // category: this.currentSelectedCategory
        },
        component: AddHotel,
        hasModalCard: true
      });
    },

    uploadImage(hotel) {
      UploadService(this.files[0], 'hotels', hotel.docId)
        .then(() => {
          this.isLoading = false;
          this.$toast.open('Image saved successfully');
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.open('Error saving image');
        });
    }
  }
};
</script>

<style scoped>
.categories-container {
  padding: 0.5rem;
}
.hotels-container {
  height: 80vh !important;
  overflow-y: scroll;
}
.hotel-image {
  height: 50px;
  margin-left: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  border-radius: 50%;
 
}



</style>



// WEBPACK FOOTER //
// src/pages/hotels/Hotels.vue